"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudTypeEnum = void 0;
/** 产品一级形态 */
var CloudTypeEnum;
(function (CloudTypeEnum) {
    /** 公有云 */
    CloudTypeEnum["PublicCloud"] = "PublicCloud";
    /** 私有云 */
    CloudTypeEnum["PrivateCloud"] = "PrivateCloud";
    /** 非云 */
    CloudTypeEnum["NonCloud"] = "NonCloud";
})(CloudTypeEnum || (exports.CloudTypeEnum = CloudTypeEnum = {}));
